import axios from "axios";
import { baseUrl3, config, requestID, getUser, baseUrl } from "../../common/utils";

const API_PREFIX = `${baseUrl3()}campaigns/`;

// export const createCampaign = async (formData) => {
//   const user = getUser();
//     if (!user) throw new Error("User not authenticated");
//     try {
//         const response = await axios.post(`${baseUrl3}/sabiShare/createCampaign`, {
//             ...formData,
//             requestID: requestID(),
//             userID: user?.id
//         }, config);
//         return response.data;
//     } catch (error) {
//         console.error("Error creating campaign:", error);
//         throw error;
//     }
// }

export const createCampaign = async (formData: any) => {
  const user = getUser();
  console.log("user:", user);
  if (!user) throw new Error("User not authenticated");

  try {
    // Check if it's FormData (file upload case)
    let payload: any;
    let headers = { ...config.headers };

    if (formData instanceof FormData) {
      // Append required fields to FormData
      formData.append("requestID", requestID());
      // formData.append("userID", user?.id);

      payload = formData;
      headers["Content-Type"] = "multipart/form-data";
    } else {
      // Standard JSON request
      payload = {
        ...formData,
        requestID: requestID(),
        // userID: user?.id,
      };
    }

    const response = await axios.post(
      `${baseUrl()}campaigns/createCampaign`,
      payload,
      {
        ...config,
        headers,
      }
    );
    console.log("createCampaign response:", response);

    return response.data;
  } catch (error) {
    console.error("Error creating campaign:", error);
    throw error;
  }
};

export const getCampaigns = async () => {
  const user = getUser();
  if (!user) throw new Error("User not authenticated");
  try {
    const response = await axios.post(
      `${baseUrl()}getAllUserCampaigns`,
      {
        requestID: requestID(),
      },
      config
    );
    console.log("getCampaigns response:", response);
    return response.data; // expect array of campaigns
  } catch (error) {
    console.error("Error fetching campaigns:", error);
    throw error;
  }
};

export const deleteCampaign = async (campaignId: string) => {
  try {
    const response = await axios.post(
      `${API_PREFIX}deleteCampaign`,
      {
        requestID: requestID(),
        campaign_id: campaignId,
      },
      config
    );
    console.log("deleteCampaign response:", response);
    return response.data;
  } catch (error) {
    console.error("Error deleting campaign:", error);
    throw error;
  }
};

export const getCampaignById = async (campaignId: string) => {
  const user = getUser();
  if (!user) throw new Error("User not authenticated");
  try {
    const response = await axios.post(
      `${API_PREFIX}getCampaignByUserAndId`,
      {
        requestID: requestID(),
        campaign_id: campaignId,
      },
      config
    );
    console.log("getCampaignById response:", response);
    return response.data; // expect campaign object
  } catch (error) {
    console.error("Error fetching campaign:", error);
    throw error;
  }
};

export const updateCampaign = async (campaignId: string, payloadData: any) => {
  const user = getUser();
  if (!user) throw new Error("User not authenticated");
  try {
    let payload: any;
    let headers = { ...config.headers };

    if (payloadData instanceof FormData) {
      payloadData.append("requestID", requestID());
      payloadData.append("userID", user?.id);
      payload = payloadData;
      headers["Content-Type"] = "multipart/form-data";
    } else {
      payload = {
        ...payloadData,
        requestID: requestID(),
        userID: user?.id,
      };
    }

    const response = await axios.post(
      `${API_PREFIX}editCampaign/${campaignId}`,
      payload,
      {
        ...config,
        headers,
      }
    );
    console.log("updateCampaign response:", response);

    return response.data;
  } catch (error) {
    console.error("Error updating campaign:", error);
    throw error;
  }
};

export const getWalletBalance = async () => {
  try {
    const res = await axios.post(
      `${baseUrl()}/wallets/getWalletBalance`,
      {
        requestID: requestID(),
      },
      config
    );
    console.log("getWalletBalance response:", res);
    return res.data;
  } catch (error) {
    console.error("Error fetching wallet balance:", error);
    throw error;
  }
};

export const getVendorsByState = async (state: string) => {
  try {
    const res = await axios.post(
      `${API_PREFIX}vendorsByState`,
      {
        state,
        requestID: requestID(),
      },
      config
    );
    return res.data;
  } catch (error) {
    console.error("Error fetching vendors:", error);
    throw error;
  }
};

export const getWalletTransactions = async () => {
  try {
    const res = await axios.post(
      `${API_PREFIX}walletTransactions`,
      {
        requestID: requestID(),
      },
      config
    );
    return res.data;
  } catch (error) {
    console.error("Error fetching transactions:", error);
    throw error;
  }
};

export const getCampaignVouchers = async (campaignId: string) => {
  try {
    if (!campaignId) throw new Error("No campaign ID provided");
    const res = await axios.post(
      `${API_PREFIX}getCampaignsVouchers`,
      {
        campaign_id: campaignId,
        requestID: requestID(),
      },
      config
    );
    console.log("getCampaignVouchers response:", res);
    return res.data;
  } catch (error) {
    console.error("Error fetching campaign vouchers:", error);
    throw error;
  }
};

// export const getCampaignBeneficiaries = async (campaignId: string) => {
//   try {
//     if (!campaignId) throw new Error("No campaign ID provided");
//     const res = await axios.post(
//       `${API_PREFIX}getCampaignsBeneficiary`,
//       {
//         campaign_id: campaignId,
//         requestID: requestID(),
//       },
//       config
//     );
//     console.log("getCampaignBeneficiaries response:", res);
//     return res.data;
//   } catch (error) {
//     console.error("Error fetching campaign beneficiaries:", error);
//     throw error;
//   }
// };


export const getCampaignBeneficiaries = async (campaignId: string) => {
  try {
    if (!campaignId) throw new Error("No campaign ID provided");
    const res = await axios.post(
      `${API_PREFIX}getCampaignsBeneficiary`,
      {
        campaign_id: campaignId,
        requestID: requestID(),
      },
      config
    );
    console.log("getCampaignBeneficiaries response:", res);
    return res.data; // This returns the data directly
  } catch (error) {
    console.error("Error fetching campaign beneficiaries:", error);
    throw error;
  }
};


export const getCampaignVendors = async (campaignId: string) => {
  try {
    if (!campaignId) throw new Error("No campaign ID provided");
    const res = await axios.post(
      `${API_PREFIX}getCampaignsVendors`,
      {
        campaign_id: campaignId,
        requestID: requestID(),
      },
      config
    );
    console.log("getCampaignVendors response:", res);
    return res.data;
  } catch (error) {
    console.error("Error fetching campaign vendors:", error);
    throw error;
  }
};
// export const getVendorsCampaignPayment = async (campaignId: string, vendorId: string) => {
//   try {
//     if (!campaignId) throw new Error("No campaign ID provided");
//     const res = await axios.post(
//       `${API_PREFIX}getCampaignsVendors`,
//       {
//         campaign_id: campaignId,
//         vendor_id: vendorId,
//         requestID: requestID(),
//       },
//       config
//     );
//     console.log("getCampaignVendors response:", res);
//     return res.data;
//   } catch (error) {
//     console.error("Error fetching campaign vendors:", error);
//     throw error;
//   }
// };


export const getAllCampaigns = async () => {
  try {
    const res = await axios.post(
      baseUrl3() +
        `Analytics/getCampaigns`,
      {
        requestID: requestID(),
      },
      config
    );
    console.log("getCampaigns responsesssss:", res);
    return res.data;
  } catch (error) {
    console.error("Error fetching campaign vendors:", error);
    throw error;
  }
};
export const getCampaignFullDetails = async (campaignId) => {
  try {
    const res = await axios.post(
      baseUrl3() +
        `Analytics/getCampaignFullDetails`,
      {
        requestID: requestID(),
        campaign_id: campaignId
      },
      config
    );
    console.log("getCampaigns response:", res);
    return res.data;
  } catch (error) {
    console.error("Error fetching campaign vendors:", error);
    throw error;
  }
};
export const getVendorsCampaignPayment = async (campaignId,vendorId) => {
  try {
    const res = await axios.post(
      baseUrl3() +
        `Analytics/getVendorCampaignFullPayments`,
      {
        requestID: requestID(),
        campaign_id: campaignId,
        vendor_id: vendorId
      },
      config
    );
    console.log("get vendor Campaigns response:", res);
    return res.data;
  } catch (error) {
    console.error("Error fetching campaign vendors:", error);
    throw error;
  }
};